import { render, staticRenderFns } from "./Switch_comp.vue?vue&type=template&id=4ad9ea2a&scoped=true&"
import script from "./Switch_comp.vue?vue&type=script&lang=js&"
export * from "./Switch_comp.vue?vue&type=script&lang=js&"
import style0 from "./Switch_comp.vue?vue&type=style&index=0&id=4ad9ea2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad9ea2a",
  null
  
)

export default component.exports